import { Response } from 'miragejs'
import { paginate } from '../utils/index'

export function awardRoutes() {
  const restPrefix = process.env.MOCK_REST_URL_SUFIX
  this.urlPrefix = process.env.MOCK_BASE_APIS_URL
  this.timing = 3000

  this.get(`${restPrefix}/partners/awards`, (schema, request) => {
    const route_path = `${this.urlPrefix}/partners/awards`
    const { queryParams: { page = 1, limit = 18} } = request

    let awards = schema.db.awards

    const { paginatedItems, meta} = paginate(
      awards,
      Number(page),
      Number(limit)
    );

    return new Response(200, {}, {
      data: paginatedItems,
      links: {
        first: `${route_path}?page=1`,
        last: `${route_path}?page=${meta.last_page}`,
        prev: null,
        next: null
      },
      meta,
    })
  })
}



// WEBPACK FOOTER //
// ./src/mocks/routes/awards.js